<script>
  import { navigateTo } from 'svelte-router-spa';
  import { isLoggedIn } from '../../utils/store';

  import LogoutButton from './LogoutButton.svelte';

  function navigateToHome() {
    navigateTo('/');
  }

  async function logout() {
    const response = await fetch(process.env.BACKEND_URL + 'logout', {
      method: 'GET',
      credentials: 'include',
    });

    if (response.ok) {
      isLoggedIn.set(false);
      navigateTo('/login');
    } else {
      console.error(response);
    }
  }
</script>

<nav class="navbar navbar-light bg-light sticky-top">
  <div class="container-fluid">
    <button
      on:click|preventDefault={navigateToHome}
      class="btn btn-lg btn-info"
    >
      Anasayfa
    </button>
    <LogoutButton />
  </div>
</nav>
